module.exports = __webpack_public_path__ + "img/chambre 6.782956bd.jpeg";